@if (isReadOnly) {
  <div class="applied-coupons-container">
    @if (sortedVouchers.length > 0) {
      <div>
        <div class="cx-applied-coupon-title">
          {{ 'voucher.vouchersApplied' | cxTranslate }}
        </div>
      </div>
    }
    @for (voucher of sortedVouchers; track voucher) {
      <div
        class="coupon-summary cx-coupon-card textonly"
        role="filter"
        >
        <span class="cx-applied-coupon-code">{{ voucher.voucherCode }}</span>
      </div>
    }
  </div>
} @else {
  <div class="row">
    @for (voucher of sortedVouchers; track voucher) {
      <div
        class="cx-coupon-card-grid"
        role="filter"
        >
        <div class="cx-coupon-apply cx-coupon-card cx-coupon-list-wrap">
          <span class="cx-cart-coupon-code">{{ voucher.voucherCode }}</span>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="removeVoucher(voucher.voucherCode)"
            [disabled]="cartIsLoading"
            [class.disabled]="cartIsLoading"
            >
            <span aria-hidden="true">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
            </span>
          </button>
        </div>
      </div>
    }
  </div>
}

